module.exports = __webpack_public_path__ + "assets/img/kv-6e1cb461.jpg";